import {
    DealerDashboardDTO,
    DealerDashboardClient_V1
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';

export default class DashboardService {
    private readonly _dealerDashboardClient: DealerDashboardClient_V1;

    constructor() {
        this._dealerDashboardClient = new DealerDashboardClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public Data(dealerAccountUid: string): Promise<DealerDashboardDTO> {
        return this._dealerDashboardClient.getDashboardData(dealerAccountUid);
    }
}